module.exports = __webpack_public_path__ + "img/pile3.cea9c2c3.png";